export interface DescribedUserAgent {
  /** "Chrome on macOS", "Safari on iPhone", "Unknown browser". */
  label: string;
  device: "desktop" | "mobile";
}

// Order matters: Edge and Opera say "Chrome", Chrome says "Safari".
const BROWSERS: [RegExp, string][] = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Safari\//, "Safari"],
];

const SYSTEMS: [RegExp, string][] = [
  [/iPhone/, "iPhone"],
  [/iPad/, "iPad"],
  [/Android/, "Android"],
  [/Windows/, "Windows"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/CrOS/, "ChromeOS"],
  [/Linux/, "Linux"],
];

/** A signed-in browser in words, from its User-Agent header. Good enough to recognise, not to trust. */
export function describeUserAgent(ua: string | null | undefined): DescribedUserAgent {
  if (!ua) return { label: "Unknown browser", device: "desktop" };
  const browser = BROWSERS.find(([re]) => re.test(ua))?.[1];
  const system = SYSTEMS.find(([re]) => re.test(ua))?.[1];
  const label = browser && system ? `${browser} on ${system}` : (browser ?? system ?? "Unknown browser");
  return { label, device: /Mobi|iPhone|iPad|Android/.test(ua) ? "mobile" : "desktop" };
}
